import React, { Component } from 'react';
//import logo from './logo.svg';
import { connect } from 'react-redux'
import { initLocation } from './actions'


class RedSocial extends Component {
  constructor(props){
    super(props)
    this.state = {
      country: '' 
    }
  }

  componentWillReceiveProps(next_props) {

    if(next_props.country.location !== this.state.country){
      this.setState({
        country: next_props.country.location
      });
    }

  }

  render() {
    if(this.state.country === 'INT'){
      return (
        <div>
          <a href="https://www.facebook.com/Ivcnet-1733388843548934/?ref=br_rs"><i className="fab fa-facebook-f" /></a>
          <a href="https://twitter.com/ivcnetworks"><i className="fab fa-twitter" /></a>
          <a href="https://www.instagram.com/ivcnetworks/"><i className="fab fa-instagram" /></a>
          <a href="https://www.youtube.com/channel/UCz22gaAIPdIfkYOSXYG6bqQ"><i className="fab fa-youtube" /></a>
          <a href="/page/search"><i className="fas fa-search" /></a>
        </div>
      );
    }
    if(this.state.country === 'VE'){
      return (
        <div>
          <a href="https://www.facebook.com/Ivcnet-1733388843548934/?ref=br_rs"><i className="fab fa-facebook-f" /></a>
          <a href="https://twitter.com/ivcnetworksve"><i className="fab fa-twitter" /></a>
          <a href="https://www.instagram.com/ivcnetworksve/"><i className="fab fa-instagram" /></a>
          <a href="https://www.youtube.com/channel/UCz22gaAIPdIfkYOSXYG6bqQ"><i className="fab fa-youtube" /></a>
          <a href="/page/search"><i className="fas fa-search" /></a>
        </div>
      );
    }
    if(this.state.country === 'US'){
      return (
        <div>
          <a href="https://www.facebook.com/Ivcnet-1733388843548934/?ref=br_rs"><i className="fab fa-facebook-f" /></a>
          <a href="https://twitter.com/ivcnetworks"><i className="fab fa-twitter" /></a>
          <a href="https://www.instagram.com/ivcnetworks/"><i className="fab fa-instagram" /></a>
          <a href="https://www.youtube.com/channel/UCz22gaAIPdIfkYOSXYG6bqQ"><i className="fab fa-youtube" /></a>
          <a href="/page/search"><i className="fas fa-search" /></a>
        </div>
      );
    }
    return (
        <div>
          <a href="https://www.facebook.com/Ivcnet-1733388843548934/?ref=br_rs"><i className="fab fa-facebook-f" /></a>
          <a href="https://twitter.com/ivcnetworks"><i className="fab fa-twitter" /></a>
          <a href="https://www.instagram.com/ivcnetworks/"><i className="fab fa-instagram" /></a>
          <a href="https://www.youtube.com/channel/UCz22gaAIPdIfkYOSXYG6bqQ"><i className="fab fa-youtube" /></a>
          <a href="/page/search"><i className="fas fa-search" /></a>
        </div>
      );
  }
}

function mapStateToProps (reducer){
  return {
    country: reducer.country
  }
}

function mapDispathToProps (dispatch){
  return {
    getLocation: (data) => dispatch(initLocation(data)),
  }
}

export default connect(mapStateToProps, mapDispathToProps)(RedSocial)



// WEBPACK FOOTER //
// ./src/redsocial.js